import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";
import {allArtistRoles} from "../../data/Enums";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";

const ArtistsItemBrowserHeader = ({
                                      mainRoleId,
                                      setMainRoleId,
                                      tagId,
                                      setTagId,
                                      ...restProps
                                  }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSimpleSelect
                    label="Основной род деятельности"
                    options={mainRoleOptions}
                    value={mainRoleId}
                    setValue={setMainRoleId}
                />
                <ItemBrowserHeaderSelect
                    label="Наличие тега"
                    selectedId={tagId}
                    setSelectedId={setTagId}
                    apiName2="tags"
                    specialOptions={[{id: 0, name: "(не важно)"}]}
                    showIds={true}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const mainRoleOptions = [{id: 0, name: "(все)"}, ...allArtistRoles];

export default ArtistsItemBrowserHeader;